import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { ClipboardEvent, DragEvent, ReactNode, useEffect, useState } from 'react';

export interface TypeNameToConfirmDialogProps {
  open: boolean;
  name: string;
  inputLabel?: string;
  title: string;
  content?: ReactNode;
  confirmLabel: string;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const blockInsert = (event: ClipboardEvent | DragEvent) => event.preventDefault();

const TypeNameToConfirmDialog = ({ open, name, inputLabel = 'Name', title, content, confirmLabel, loading = false, onConfirm, onClose }: TypeNameToConfirmDialogProps) => {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (!open) setTyped('');
  }, [open]);

  const matches = name.trim() !== '' && typed.trim() === name.trim();

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {content && <DialogContentText sx={{ mb: 2 }}>{content}</DialogContentText>}
        <DialogContentText sx={{ mb: 1 }}>
          Type <strong>{name}</strong> to confirm.
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label={inputLabel}
          value={typed}
          onChange={(event) => setTyped(event.target.value)}
          onPaste={blockInsert}
          onDrop={blockInsert}
          autoComplete="off"
          inputProps={{ spellCheck: false, autoCorrect: 'off', autoCapitalize: 'off' }}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={!matches || loading} startIcon={loading ? <CircularProgress size={14} color="inherit" /> : undefined}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TypeNameToConfirmDialog;
